import React from 'react';
import { cn } from 'lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ children, variant = 'primary', size = 'sm', className, ...props }, ref) => {
    const variants = {
      primary: 'bg-muted text-foreground/80',
      secondary: 'bg-muted text-foreground/80',
      success: 'bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-400',
      warning: 'bg-warning-50 text-warning-700 dark:bg-warning-900/30 dark:text-warning-400',
      danger: 'bg-error-50 text-error-700 dark:bg-error-900/30 dark:text-error-400',
      info: 'bg-muted text-foreground',
      outline: 'border border-border bg-transparent text-muted-foreground',
    };

    const sizes = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-2.5 py-0.5 text-xs',
      lg: 'px-3 py-1 text-sm',
    };

    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center gap-1 rounded-md font-medium',
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export { Badge };
export default Badge;
